import React, { Component } from 'react';
import { Link, Redirect } from "react-router-dom";
import AsanConfirmationIcon from "./img/asan-confirmation-icon.svg";
import headerLogo from "./img/header-logo.svg";
import { translate } from 'react-i18next';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';

class ConfirmPinModal extends Component {

    state = {
        open: false,
    }

    prevPage = () => {
        this.props.closeFunction();
    }

    render() {
        let { t, verificationCode, open, feedbackMessage } = this.props;

        return (
            <Modal
                open={open}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: "100%" }}
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description">
                <Fade in={open} style={{
                    display: 'inline-block',
                    maxHeight: '100vh',
                    overflow: 'auto',
                    width: '100%'
                }}>
                    <div >
                        <div className="registration">
                            <Link to="/">
                                <img src={headerLogo} className="registration-logo" alt="headerLogo" />
                            </Link>
                            <div className="registration-container registration-container--top-border">
                                <h2 className="registration-container-title registration-container-title--center">{t('asan signature confirmation')}</h2>
                                <p className="registration-container-description registration-container-description--center">{t('please accept the request sent to your phone')}</p>
                                <img src={AsanConfirmationIcon} className="registration-container-icon" alt="AsanConfirmationIcon" />
                                <div className="registration-container-asan-confirmation">
                                    <span className="registration-container-asan-confirmation-code">{verificationCode}</span>
                                </div>
                                <div className="registration-container-validation-feedback text-center">
                                    {
                                        feedbackMessage ? <p className="registration-container-validation-feedback-message">{feedbackMessage}</p> : null
                                    }
                                </div>
                                {/* <div className="registration-container-footer"> */}
                                {/* <button type="button" className="registration-container-footer-button registration-container-footer-button--left" onClick={() => this.props.closeFunction()}>{t('back')}</button> */}
                                {/* <button type="button" className="registration-container-footer-button registration-container-footer-button--right" disabled={isDisabled}>{t('next')}</button> */}
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                </Fade>
            </Modal>
        )
    }
}


export default translate("translation")(ConfirmPinModal);